import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
var EXTERNAL_PATHS = ['blog', 'classes', 'home', 'press-room', 'referral_campaign', 'reserve_class', 'settings/membership', 'studios'];
var EXTERNAL_REGEXP = new RegExp("^/?\\b(".concat(EXTERNAL_PATHS.join('|'), ")\\b"));
var EXTERNAL_DOMAIN_REGEXP = new RegExp('^https?://');
export var isExternal = function isExternal(path) {
  return EXTERNAL_REGEXP.test(path) || EXTERNAL_DOMAIN_REGEXP.test(path);
};
export var isExternalDomain = function isExternalDomain(path) {
  return EXTERNAL_DOMAIN_REGEXP.test(path);
};
export var redirectTo = function redirectTo(pathname) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 301;
  return function (_, replace, cb) {
    return cb(replace({
      pathname: pathname,
      state: {
        status: status
      }
    }));
  };
};
export var toExternalHref = function toExternalHref(href) {
  var secure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var protocol = secure ? 'https://' : 'http://';
  return href.toLowerCase().indexOf('http') === 0 ? href : "".concat(protocol).concat(href);
};